import type React from "react";

interface LoaderWrapperProps {
	children: React.ReactNode;
}

/**
 * Wrapper component for loading state
 */
export const LoaderWrapper: React.FC<LoaderWrapperProps> = ({ children }) => {
	return (
		<div className="loader-container loader-container--center loader-container--full-height">
			{children}
		</div>
	);
};
